export function extractFirstNameAndLastName(displayName: string): [string, string] {
  if (!displayName) {
    return undefined;
  }
  const displayNameComponents = displayName.split(/\s+/);
  if (displayNameComponents && displayNameComponents.length >= 2) {
    return [displayNameComponents[ 0 ], displayNameComponents[ 1 ]];
  } else {
    return undefined;
  }
}

export function isNullOrUndefined(value: any) {
  return value === null || value === undefined;
}

export function isiOS(): boolean {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
  if (/iPad|iPhone|iPod/.test(userAgent) && !((window as any).MSStream)) {
    return true;
  }
  return false;
}
